import * as state from './state.js';
let getters = {
    getBaseUrl: state => {
        return state.url;
    },
};
export default getters;


// WEBPACK FOOTER //
// ./src/vuex/modules/baseUrl/getters.js